import { z } from 'zod';

const EnvSchema = z.object({
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_SENTRY_DSN: z.string().min(1),
  // Comma-separated list of Google account emails allowed to sign in as admin.
  VITE_ADMIN_EMAILS: z
    .string()
    .transform((value) =>
      value
        .split(',')
        .map((email) => email.trim())
        .filter((email) => email.length > 0),
    )
    .pipe(z.array(z.string().email()).min(1)),
});

// Fails fast at boot if a var is missing, instead of failing later
// inside whichever Firebase call happens to read it first.
export const env = EnvSchema.parse(import.meta.env);
